import { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { AUTH_F } from '@/constants/testIds/healthspan';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim(), password);
      toast.success('Signed in');
      const next = new URLSearchParams(loc.search).get('next') || '/dashboard';
      nav(next);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Sign in failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto">
      <Card className="p-6 sm:p-8 rounded-[var(--radius-md)] border border-[color:var(--border-color)] bg-[color:var(--surface)]">
        <h1 className="text-xl font-semibold tracking-tight">Sign in</h1>
        <p className="mt-1 text-sm text-[color:var(--muted-fg)]">Welcome back. Continue your research session.</p>
        <form data-testid={AUTH_F.loginForm} onSubmit={submit} className="mt-6 space-y-4">
          <div className="space-y-1">
            <Label htmlFor="email">Email</Label>
            <Input data-testid={AUTH_F.loginEmail} id="email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} />
          </div>
          <div className="space-y-1">
            <Label htmlFor="password">Password</Label>
            <Input data-testid={AUTH_F.loginPassword} id="password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} />
          </div>
          <Button data-testid={AUTH_F.loginSubmit} type="submit" disabled={busy} className="w-full bg-[color:var(--brand-primary)] text-[color:var(--brand-primary-fg)] hover:bg-[color:var(--brand-primary-2)]">{busy ? 'Signing in…' : 'Sign in'}</Button>
        </form>
        <p className="mt-4 text-sm text-[color:var(--muted-fg)]">New here? <Link to="/register" className="underline underline-offset-4">Create an account</Link></p>
      </Card>
    </div>
  );
}
